import { SHOW_SECRET_MENU, UNLOCK_SECRET_MENU, TOGGLE_SECRET_MENU, REGISTER_NATIVE_HEIGHT } from '../../constants';
const initialState = {
    isLoading: false,
    showSecretMenu: false,
    unlockedSecretMenu: false,
    displaySecretMenuBanner: false,
    nativeDeviceHeight: 0,
};
const SecretMenuReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_SECRET_MENU:
            return {
                ...state,
                isLoading: false,
                showSecretMenu: action.payload,
            };
        case UNLOCK_SECRET_MENU:
            return {
                ...state,
                unlockedSecretMenu: action.flag,
            };
        case TOGGLE_SECRET_MENU:
            return {
                ...state,
                displaySecretMenuBanner: action.flag,
            };
        case REGISTER_NATIVE_HEIGHT:
            return {
                ...state,
                nativeDeviceHeight: action.height,
            };
        default:
            return state;
    }
};
export default SecretMenuReducer;
